import { useQuery } from '@tanstack/react-query'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

import { useBrandAccountId } from './useBrandAccountId'
import { useMainQueryKey } from './useMainQueryKey'

const document = graphql(`
  query BrandAccountAllowedDomainListPage_Main($brandAccountId: ID!) {
    brandAccountAllowDomains(brandAccountId: $brandAccountId) {
      allowDomain
    }
  }
`)

export const useMainQuery = () => {
  const graphQLRequest = useGraphQLRequest()
  const brandAccountId = useBrandAccountId()
  const queryKey = useMainQueryKey()

  return useQuery({
    queryFn: async () => {
      const result = await graphQLRequest({
        document,
        variables: { brandAccountId },
      })

      return (
        result.brandAccountAllowDomains?.map((item) => ({
          value: item.allowDomain,
        })) ?? []
      )
    },
    queryKey,
  })
}

export type AllowedDomain = QueryResultOf<typeof useMainQuery>[number]
